import {useParams,} from "react-router-dom";
import Button from "../../components/Button";
import LoadingSplash from "../../components/LoadingSplash";
import {PaymentDetails, useOrderByRef} from "../../hooks/useOrders";
import {getErrMsg} from "@/lib/errors.ts";


export default function CheckoutStatusPage() {
    const {reference = ""} = useParams();

    const {data, isLoading, isError, error, refetch, isFetching} = useOrderByRef({reference: reference});

    if (isLoading) {
        return <LoadingSplash message={"Kontroleer tans jou betalingsstatus..."} />;
    }

    if (isError) {
        return <ErrorState message={getErrMsg(error)}/>;
    }

    return (
        <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-gray-50">
            {renderStatusContent(data, reference)}
        </div>
    );
}

function ErrorState({message}: { message: string }) {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center text-center p-6">
            <h1 className="text-2xl font-semibold text-red-600 mb-2">Betalingsfout</h1>
            <p className="text-gray-600 mb-4">{message}</p>
            <Button
                variant="secondary"
                to="/"
            >
                Terug na Tuisblad
            </Button>
        </div>
    );
}

function renderStatusContent(details: PaymentDetails | null, reference: string | null) {
    if (!details) return null;

    switch (details.status) {
        case "failed":
            return <FailedStatus reference={reference}/>;
        case "success":
            return <SuccessStatus details={details}/>;
        case "pending":
        default:
            return <PendingStatus reference={reference}/>;
    }
}

function SuccessStatus({
                           details
                       }: {
    details: PaymentDetails
}) {
    return (
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center max-w-md w-full">
            <h1 className="text-2xl font-semibold text-green-600 mb-2">
                {details.amount === 0 ? "Registrasie Bevestig" : "Betaling Suksesvol"}
            </h1>
            <p className="text-gray-700 mb-6">
                {details.amount === 0
                    ? "Jy is suksesvol vir die kompetisie geregistreer."
                    : "Dankie vir jou betaling. Jou transaksie was suksesvol."
                }
            </p>
            <p className="text-gray-600 text-start mb-6">
                <strong>Bestellingsbesonderhede:</strong><br/>
                Beskrywing: <strong>{details.description}</strong><br/>
                Deelnames: <strong>{details.entries}</strong><br/>
                Bedrag: <strong>{details.currency}{details.amount.toFixed(2)}</strong><br/>
                Verwysing: <strong>{details.reference}</strong>
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <Button variant="secondary" to="/">
                    Terug na Tuisblad
                </Button>
            </div>
        </div>
    );
}

function PendingStatus({
                           reference
                       }: {
    reference: string | null
}) {
    return (
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center max-w-md w-full">
            <h1 className="text-2xl font-semibold text-yellow-600 mb-2">Betaling Hangend</h1>
            <p className="text-gray-700 mb-6">
                Jou betaling word verwerk. Dit kan ’n paar oomblikke neem.
            </p>
            <p className="text-gray-600 mb-6">
                Verwysing: <strong>{reference}</strong>
            </p>
            <div className="space-y-3">
                <Button
                    variant="primary"
                    fullWidth
                    onClick={() => window.location.reload()}
                >
                    Herlaai Status
                </Button>
                <Button variant="secondary" fullWidth to="/">
                    Terug na Tuisblad
                </Button>
            </div>
        </div>
    );
}

function FailedStatus({
                          reference
                      }: {
    reference: string | null
}) {
    return (
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center max-w-md w-full">
            <h1 className="text-2xl font-semibold text-red-600 mb-2">Betaling Gefaal</h1>
            <p className="text-gray-700 mb-6">
                Ons kon nie jou betaling voltooi nie. Probeer asseblief weer.
            </p>
            <p className="text-gray-600 mb-6">
                Verwysing: <strong>{reference}</strong>
            </p>
            <div className="space-y-3">
                <Button variant="secondary" fullWidth to="/">
                    Terug na Tuisblad
                </Button>
                <Button
                    variant="primary"
                    fullWidth
                    onClick={() => window.location.reload()}
                >
                    Herlaai Status
                </Button>
            </div>
        </div>
    );
}
